import { formatDecimalNumber } from "../../../services/helpers/formatDecimalNumber"
import BodyFeatures from "./body_features"
import Carousel from "./carousel"
import CopyLinkNew from "./copy_link_new"
import Pdf from "./generate_pdf"
import './styles.css'

function BodyInformation({ property }) {
  return (
    <div>
      <div className="body-information-wrapper">
        {property.data?.images &&
          <Carousel images={property?.data?.images} />
        }
        <div className="card-body p-0 mt--6px">
          <div className='h-87 d-flex align-items-center justify-content-end px-md-5 px-2'>
            <h3 className='margin-r-10'>Precio desde </h3>
            <h2 className='pr-md-2 pr-0'>{formatDecimalNumber(property?.data?.price.value)}</h2>
          </div>

          <div className='body-information-table'>
            <span className='subhead-light text-black align-center bg-soft-gray px-4 body-information-row'>
              Superficie: <span className='subhead-bold'>{property?.data?.total_area && property?.data?.total_area.toString().replace('.', ',')} Mts2.</span>
            </span>
            <span className='subhead-light text-black align-center bg-soft-gray px-4 body-information-row'>
              Dormitorios: <span className='subhead-bold ml-5px'> {property?.data?.quantity_rooms}</span>
            </span>
            <span className='subhead-light text-black align-center bg-soft-gray px-4 body-information-row'>
              Baños: <span className='subhead-bold ml-5px'> {property?.data?.quantity_bathrooms}</span>
            </span>
            <span className='subhead-light text-black align-center bg-soft-gray px-4 body-information-row'>
              Estacionamientos: <span className='subhead-bold ml-5px'> {property?.data?.parking ? 'Sí' : 'No'} </span>
            </span>
          </div>

          <div className='px-4'>
            <div className='my-4 align-items-center description-top'>
              <h3 className='text-black'>Descripción</h3>
              <div className="body-information-buttons-wrapper">
                <Pdf property={property} />
                <CopyLinkNew property={property} />
              </div>
            </div>
            <div
              className="microcopy-light property-description line-height-30"
              style={{ fontSize: '16px' }}
              dangerouslySetInnerHTML={{ __html: property?.data?.description }}
            />
            <hr className='my-5' />

            <h3 className='text-black'>Información básica</h3>
            <div className="row">
              <div className="col-md-6 col-12">
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Precio: <span className='subhead-bold'>{property?.data?.price.currency.symbol}{formatDecimalNumber(property?.data?.price.value)}</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Tipo: <span className='subhead-bold'>{property?.data?.type.name}</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Sup. Total: <span className='subhead-bold'>{property?.data?.total_area && property?.data?.total_area.toString().replace('.', ',')} Mts2</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Estacionamiento: <span className='subhead-bold'>{property?.data?.parking ? 'Sí' : 'No'}</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Baños: <span className='subhead-bold'>{property?.data?.quantity_bathrooms}</span>
                </span>
              </div>
              <div className="col-md-6 col-12">
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Operación: <span className='subhead-bold'>{property?.data?.modality.name}</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Sup. Útil: <span className='subhead-bold'>{property?.data?.useful_surface && property?.data?.useful_surface.toString().replace('.', ',')} Mts2</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Gasto común: <span className='subhead-bold'>${formatDecimalNumber(property?.data?.common_expenses.amount)}</span>
                </span>
                <span className='subhead-light d-block mt-2 text-$medium-gray'>
                  Habitaciones: <span className='subhead-bold'>{property?.data?.quantity_rooms}</span>
                </span>
              </div>
            </div>


            {property.data?.features &&
              <>
                <hr className='my-5' />
                <BodyFeatures features={property?.data?.features} />
              </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default BodyInformation
